import { SELECTION_STAGE, SELECTION_TYPES } from 'client/components/common/SelectionHint/utils';
import { BBCommonProps } from 'types/story';

export const EVENT_NAME = 'SelectBB' as const;

type Options = {
	detail?: {
		trigger: 'focus' | 'select' | 'deselect';
		selectionType: typeof SELECTION_TYPES[keyof typeof SELECTION_TYPES];
		stage?: typeof SELECTION_STAGE[keyof typeof SELECTION_STAGE];
		originalEvent: Event | { totalSelected: number; shiftKey: boolean; currentTarget: { id: string } };
		componentProps: null | BBCommonProps;
	};
	bubbles?: boolean;
	cancelable?: boolean;
};

declare global {
	// eslint-disable-next-line no-unused-vars
	interface WindowEventMap {
		[EVENT_NAME]: CustomEvent;
	}
}

type Listener = (event: CustomEvent<Options['detail']>) => void;

export class SelectionHintEvent {
	/**
	 * @desc common usage is to force update of SelectionHint
	 */
	static triggerFocus(props: BBCommonProps) {
		new SelectionHintEvent({
			options: {
				detail: {
					trigger: 'focus',
					selectionType: 'clicked',
					componentProps: props,
					originalEvent: {
						totalSelected: 1,
						shiftKey: false,
						currentTarget: { id: props.uiConfig.nodeProps.id },
					},
				},
			},
		}).dispatch();
	}

	options: Options;

	listener?: Listener;

	constructor(props: { options?: Options; listener?: Listener }) {
		this.options = {
			bubbles: true,
			cancelable: false,
			...(props.options || {}),
		};

		if (props.listener) this.listener = props.listener;
	}

	addListener() {
		if (this.listener) window.addEventListener(EVENT_NAME, this.listener);
	}

	removeListener() {
		if (this.listener) window.removeEventListener(EVENT_NAME, this.listener);
	}

	dispatch() {
		window.dispatchEvent(new CustomEvent(EVENT_NAME, this.options));
	}
}
